<template v-slot="props">
  <div v-if="isLinkedTask">
    <span v-if="linkedTask.id" class="invisible">{{ linkedTask.id }}</span>
    <span v-if="canReadTask && linkedTask.id">
      <a href="#" title="View/Edit Linked Task" @click.prevent="handleEditTask">{{ getTaskName() }}</a>
    </span>
    <span v-else>
      {{ getTaskName() }}
    </span>
  </div>
  <div v-else>
    <span v-if="linkedTasks">Many ({{ linkedTasksCount }})</span>
    <span v-else>N/A</span>
  </div>
</template>

<script>
import {objectById, taskNameWithOptionalRepeatCountSuffix} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'
import Permissions from 'src/utilities/permissions'
import _ from 'lodash'

export default {
  props: ['data'],
  computed: {
    isLinkedTask() {
      return this.data.linkedTask
    },
    linkedTask() {
      return this.data.linkedTask
    },
    linkedTasks() {
      return _.get(this.data, 'fieldValues.linkedTaskIds')
    },
    linkedTasksCount() {
      return this.linkedTasks.length
    },
    user() {
      return this.$store.get('security/user')
    },
    userId() {
      return this.$store.get('security/userId')
    },
    canReadTask() {
      if (this.$can('read', Permissions.TASKS)) {
        // only let standard users edit their own tasks
        if (objectById(this.user.groups, Constants.GROUPS.STANDARD_USERS)) {
          return this.userId === this.linkedTask.assigneeId
        }
        return true
      }
      return false // users not in a group or no access
    }
  },
  methods: {
    handleEditTask() {
      this.$eventHub.$emit('show-modal-2', 'Edit Task', {id: this.linkedTask.id})
    },
    getTaskName() {
      return taskNameWithOptionalRepeatCountSuffix(this.linkedTask)
    }
  }
}
</script>
